export const allowOnlyAlphabetsNumberSpace = (e) => {
  e.target.value = e.target.value.replace(/[^a-zA-Z0-9\s]/gi, "");
};

export const allowSpecificCharacters = (e) => {
  e.target.value = e.target.value.replace(/[^a-zA-Z0-9/_\.]/g, "");
};

export const allowOnlyNumber = (e) => {
  e.target.value = e.target.value.replace(/[^0-9]/gi, "");
};

export const allowOnlyAlphabets = (e) => {
  e.target.value = e.target.value.replace(/[^a-zA-Z\s]/gi, "");
};

export const allowMailCharacters = (e) => {
  const allowed = e.target.value.replace(/[^a-zA-Z0-9@._-]/g, "");
  e.target.value = allowed;
};
